export default {
  Get: {
    PUBLISH_CERTINERGIE: 'getPublishCertinergie',
    PUBLISH_CERTIPLUS: 'getPublishCertiplus'
  },
  Set: {
    KEURING_PLATFORM_ASSIGN_VALUE: 'assignKeuringPlatformValue',
    KEURING_PLATFORM_RESET: 'resetKeuringPlatformgieValue',
    KEURING_PLATFORM_AGENCY_ASSIGN_VALUE: 'assignKeuringPlatformAgencyValue',
    KEURING_PLATFORM_AGENCY_RESET: 'resetKeuringPlatformAgencyValue',
    KEURING_PLATFORM_OWNER_ASSIGN_VALUE: 'assignKeuringPlatformOwnerValue',
    KEURING_PLATFORM_OWNER_RESET: 'resetKeuringPlatformOwnerValue',
    KEURING_PLATFORM_CONTACT_INFO_ASSIGN_VALUE: 'assignKeuringPlatformContactInfoValue',
    KEURING_PLATFORM_CONTACT_INFO_RESET: 'resetKeuringPlatformContactInfoValue'


  }
};